// 只能输入通过正则条件的字符
export default {
  bind (el, binding, vnode) {
    // 获取正则
    const regex = binding.value instanceof RegExp ? binding.value : null
    if (!regex) return

    el._handler = e => {
      e.target.value = e.target.value.replace(regex, '')
      // 触发v-model更新
      vnode.componentInstance.$emit('input', e.target.value)
    }
    el.addEventListener('input', el._handler)
  },
  unbind (el) {
    el.removeEventListener('input', el._handler)
  }
}
